const Role =  {
    ADMIN: 1,
    USER: 2,
    SUPER_ADMIN: 3,
    ROLE_ADMIN: 'Admin',
    ROLE_USER: 'User',
};

export default Role;